export default class ScrollAnimation{
    constructor(effect,pageID){

        this.effect = effect;
        this.pageID = pageID;

        this.$target = document.querySelectorAll('.js__tsc');
        this.scPoint = [];
        this.scNum = this.$target.length;
        this.scNumStart = 0;

        //flow
        this.flowList = document.getElementsByClassName("js__tsc-flow");
        this.scPointFlow = 0;

        let _Title = document.getElementsByClassName("js__tsc-title");
        let _lowlayerTitle = document.getElementsByClassName("js__tsc-title-lowlayer");
        let _moveX = document.getElementsByClassName("js__tsc-x");
        let _moveY = document.getElementsByClassName("js__tsc-y");
        let _lowlayermoveY = document.getElementsByClassName("js__tsc-y-lowlayer");
        let _moveMain = document.getElementsByClassName("js__tsc-main");
        let _Scale = document.getElementsByClassName("js__tsc-scale");
        let _pigeonLast = document.getElementsByClassName("js__pigeon-last");
        let _moveYflow = document.getElementsByClassName("js__tsc-y-flow");

        if(_Title[0]) this.effect.Title(_Title,"set");
        if(_lowlayerTitle[0]) this.effect.Title(_lowlayerTitle,"set");
        if(_moveX[0]) this.effect.moveX(_moveX,"set");
        if(_moveY[0]) this.effect.moveY(_moveY,"set");
        if(_lowlayermoveY[0]) this.effect.moveY(_lowlayermoveY,"set");
        if(_moveMain[0]) this.effect.moveMain(_moveMain,"set");
        if(_Scale[0]) this.effect.Scale(_Scale,"set");
        if(_pigeonLast[0]) this.effect.contactIllust("set");
        if(_moveYflow[0]) this.effect.flow(_moveYflow,"set");

        this.resize();

        this.status = {
            comp : false /* 全部処理が終わったか */
        }

    }
    check(inc,winH){

        if(this.flowList && !Useragnt.mobile){

            let _minusPoint = (Useragnt.pc)?winH/1.6:winH/2.4;
            if(Useragnt.mobile && this.pageID !== 'top') _minusPoint = winH/1.2;

            if(this.scPointFlow - _minusPoint < inc){
                if(document.querySelector('.js__tsc-flow.is-anime')) {
                    let _flow = document.querySelector('.js__tsc-flow.is-anime').querySelectorAll(".js__tsc-y-flow");
                    this.effect.flow(_flow,"show");
                    document.querySelector('.js__tsc-flow.is-anime').classList.remove("is-anime");
                }
            }

        }

        if(this.status.comp) return;

        let _minusPoint = (Useragnt.pc)?winH/1.6:winH/2.4;
        if(Useragnt.mobile && this.pageID !== 'top') _minusPoint = winH/1.2;

        if(this.$target){
            for(var i=this.scNumStart; this.scNum>i; i++){

                if(this.scPoint[i] - _minusPoint < inc  ) {

                    let $scp = this.$target[i];
                    if(!$scp.classList.contains('is-show')){
                        $scp.classList.add("is-show");
                        this.scNumStart += 1;

                        let _Title = $scp.querySelectorAll(".js__tsc-title");
                        let _moveX = $scp.querySelectorAll(".js__tsc-x");
                        let _moveY = $scp.querySelectorAll(".js__tsc-y");
                        let _moveMain = $scp.querySelectorAll(".js__tsc-main");
                        let _Scale = $scp.querySelectorAll(".js__tsc-scale");
                        let _svgMorph = $scp.querySelector(".js__svg-morph");

                        if(_Title) this.effect.Title(_Title,"show");
                        if(_moveX) this.effect.moveX(_moveX,"show");
                        if(_moveY) this.effect.moveY(_moveY,"show");
                        if(_moveMain) this.effect.moveMain(_moveMain,"show");
                        if(_Scale) this.effect.Scale(_Scale,"show");
                        if(_svgMorph) this.effect.svgMorph("show",_svgMorph);

                        if($scp.id === 'c-contact'){
                            this.effect.contactIllust("show");
                        }

                        if(i==this.$target.length-1) this.status.comp = true;

                    }

                }

            }

        }

    }

    resize () {

        if(this.$target){

            this.scPoint = [];
            for( var i=0; i<this.scNum; i++) {

                let $scp = this.$target[i];

                this.scPoint[i] = $scp.getBoundingClientRect().top + window.pageYOffset;
            }
        }

        if(this.flowList){

            this.scPointFlow = 0;
            if(document.querySelector('.js__tsc-flow.is-anime')) {
                this.scPointFlow = document.querySelector('.js__tsc-flow.is-anime').getBoundingClientRect().top + window.pageYOffset;
            }

        }

    }
}